module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3DnsW"))).then(() => parcelRequire('d0iPb'));